import { v4 as uuidv4 } from "uuid";
export class ProjectMembersDetailViewModel {
    constructor() {
        this.id = uuidv4();
        this.fullName = "";
        this.profileImageUrl = "";
        this.mediaFileId = "";
        this.timeEffortAsString = "";
        this.isActiveMember = true;
    }
}
export default class ProjectMembersDetailView extends ProjectMembersDetailViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
